import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { PviRequest } from '../interfaces/pvi-request.interface';
import { PviResponse } from '../interfaces/pvi-response.interface';

@Injectable({
  providedIn: 'root',
})
export class PviService {
  private readonly http = inject(HttpClient);

  public postPviSimulation(request: Partial<PviRequest>): Observable<PviResponse> {
    return this.http.post<PviResponse>('/rgg/fis/v1/pvi-simulation', request);
  }
}
